import { gql } from '@apollo/client';
import { CreatorFields, EditorFields } from '../fragments';
import { EntityCategoryFragment } from '../entityCategories';

const SearchHighlightFragment = gql`
  fragment SearchHighlightFields on SearchHighlight {
    field
    highlightedRanges {
      start
      end
    }
  }
`;
const IdSearchEntityFragment = gql`
  fragment IdSearchEntityFields on IdSearchEntity {
    type
    name
    detail
    id
    nullableBaseId: baseId
    nullableSchema: schema {
      id
      name
    }
    categories {
      ...EntityCategoryFields
    }
    creator {
      ...CreatorFields
    }
    createdAt
    editor {
      ...EditorFields
    }
    editedAt
    updatedAt
    isDisabled
  }
  ${EntityCategoryFragment}
  ${CreatorFields}
  ${EditorFields}
`;

const KeySearchEntityFragment = gql`
  fragment KeySearchEntityFields on KeySearchEntity {
    type
    detail
    name
    key
    schema {
      id
      name
    }
    categories {
      ...EntityCategoryFields
    }
    isDisabled
  }
  ${EntityCategoryFragment}
`;

const SearchDashboardFragment = gql`
  fragment SearchDashboardFields on SearchDashboard {
    type
    name
    detail
    id
    baseId
    path
    creator {
      ...CreatorFields
    }
    createdAt
    editor {
      ...EditorFields
    }
    editedAt
    updatedAt
    isDisabled
  }
  ${CreatorFields}
  ${EditorFields}
`;

const UniversalSearchAnalysisFragment = gql`
  fragment UniversalSearchAnalysisFields on SearchAnalysis {
    type
    name
    detail
    id
    schema {
      id
      name
    }
    queryType
    status
    creator {
      ...CreatorFields
    }
    createdAt
    editor {
      ...EditorFields
    }
    editedAt
    updatedAt
    isDisabled
  }
  ${CreatorFields}
  ${EditorFields}
`;

const SearchDashboardFolderFragment = gql`
  fragment SearchDashboardFolderFields on SearchDashboardFolder {
    type
    name
    detail
    id
    path
    creator {
      ...CreatorFields
    }
    createdAt
    editor {
      ...EditorFields
    }
    editedAt
    updatedAt
    isDisabled
  }
  ${CreatorFields}
  ${EditorFields}
`;

const SearchScheduleFragment = gql`
  fragment SearchScheduleFields on SearchSchedule {
    type
    scheduleType
    name
    detail
    id
    nullableSchema: schema {
      id
      name
    }
    creator {
      ...CreatorFields
    }
    createdAt
    editor {
      ...EditorFields
    }
    editedAt
    updatedAt
    isDisabled
  }
  ${CreatorFields}
  ${EditorFields}
`;

export const SearchItemFragment = gql`
  fragment SearchItemFields on SearchItem {
    entity {
      ... on IdSearchEntity {
        ...IdSearchEntityFields
      }
      ... on KeySearchEntity {
        ...KeySearchEntityFields
      }
      ... on SearchDashboard {
        ...SearchDashboardFields
      }
      ... on SearchAnalysis {
        ...UniversalSearchAnalysisFields
      }
      ... on SearchDashboardFolder {
        ...SearchDashboardFolderFields
      }
      ... on SearchSchedule {
        ...SearchScheduleFields
      }
    }
    highlight {
      ...SearchHighlightFields
    }
  }
  ${SearchHighlightFragment}
  ${IdSearchEntityFragment}
  ${KeySearchEntityFragment}
  ${SearchDashboardFragment}
  ${UniversalSearchAnalysisFragment}
  ${SearchDashboardFolderFragment}
  ${SearchScheduleFragment}
`;
